import {PagingRequest, RestClient} from "zavadil-ts-common";
import {ContactView} from "../../types/Contact";
import {SpmPage} from "../../types/SpmPage";

export class ContactsClient {

	client: RestClient;

	constructor(client: RestClient) {
		this.client = client;
	}

	filtered(
		regionId: number | null | undefined,
		sourceId: string | null | undefined,
		typeId: number | null | undefined,
		targetGroups: Array<number>,
		fulltext: string | null | undefined,
		paging: PagingRequest
	): Promise<SpmPage<ContactView>> {
		return this.client.getJson(
			'contact/filtered',
			{
				regionId: regionId || undefined,
				sourceId: sourceId || undefined,
				typeId: typeId || undefined,
				targetGroups: targetGroups.length > 0 ? targetGroups : undefined,
				fulltext: fulltext || undefined,
				size: paging.size,
				page: paging.page,
				sort: paging.sorting && paging.sorting.length > 0 ? `${paging.sorting[0].name}${paging.sorting[0].desc ? ',desc' : ''}` : undefined
			}
		);
	}

}
